import { actionCreatorFactory } from "typescript-fsa";
import { userdata } from "../typing/table_typing";


const actionCreator = actionCreatorFactory("STATUSTABLEtable");

 const resetData = actionCreator<{data:userdata}>("STatusTABLETABLE_RESETDATA");

 export const TableThingyActions = { resetData}


